import React, { useState, useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, Input, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { LoginContext } from "../../../contexts/loginContext";
import createInstance from "../../../api/axiosinstance";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const aiDishaApi = createInstance("DISHA");

const SkillManagement = () => {
  const { isLoggedIn, adminId: admin_id } = useContext(LoginContext);
  const [skillName, setSkillName] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [skillData, setSkillData] = useState([]);
  const [skillId, setSkillId] = useState(null);
  const [skillUpdate, setSkillUpdate] = useState(null);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedName, setEditedName] = useState("");
  const [deactivateId, setDeactiveId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortingOrder, setSortingOrder] = useState("asc");
  const [selectedSkill, setSelectedSkill] = useState(""); // For dropdown selection
  const [searchTerm, setSearchTerm] = useState("");
  const [skillsList, setSkillsList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const { COLORS } = useThemeMode();
  


  // const skill = [
  //   "Python",
  //   "Java",
  //   "Artificial Intelligence",
  //   "Data Science",
  //   "Automation Testing",
  //   "Devops",
  //   "React JS",
  //   "Node JS",
  //   "Scripiting languages",
  //   "Linux",
  // ];

  useEffect(() => {
    // fetchData();
    fetchSkillsForDropdown();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  // const fetchData = async () => {
  //   try {
  //     const response = await aiDishaApi.get('/skills-show/active');
  //     console.log("Fetched data:", response.data);
  //     setSkillData(response.data.skills || []);
  //   } catch (error) {
  //     console.error(
  //       "Error fetching skill data:",
  //       error.response?.data?.message || error.message
  //     );
  //   }
  // }

  const fetchSkillsForDropdown = async () => {
    try {
      const response = await aiDishaApi.get('/all-skill/');
      if (response.data) {
        console.log("fetching all values of skill", response.data)
        setSkillsList(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching skills for dropdown:", error.message);
    }
  };

  useEffect(() => {
    if (skillName === "") {
      setPage(0); // Reset pagination to the first page
      setIsEdit(false); // Exit edit mode
    }
  }, [skillName]);

  const handleSort = (field) => {
    const sortedData = [...skillData].sort((a, b) => {
      if (sortingOrder === "asc") {
        return a[field].localeCompare(b[field]);
      } else {
        return b[field].localeCompare(a[field]);
      }
    });
    setSkillData(sortedData);
    setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSkillChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedSkill(selectedValue);
    setSkillName(selectedValue); // Ensure skillName gets updated with selectedSkill
  };

  // Alternative format if your API expects it differently

const handleSkillSubmit = async () => {
  try {
    if (!skillName.trim()) {
      Toast.error("Skill name cannot be empty");
      return;
    }

    const formData = new FormData();
    formData.append("skill_name", skillName);
    formData.append("status", "Active"); // default status


    const response = await aiDishaApi.post("/admin-skills/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200 || response.status === 201) {
      Toast.success("Skill added successfully");
      setSkillName(""); 
      setSelectedSkill(""); 
      fetchSkillsForDropdown()
      // fetchData();
    }
  } catch (error) {
    if (error.response?.status === 409) {
      Toast.error("This skill already exists in the system");
    } else {
      Toast.error("Failed to add skill. Please try again.");
      console.error("Error:", error);
    }
  }
};
// const handleSkillSubmit = async () => {
//   try {
//     if (!skillName.trim()) {
//       Toast.error("Skill name cannot be empty");
//       return;
//     }

//     // const existingSkill = skillData.find(
//     //   (skill) => skill.skill_name.toLowerCase() === skillName.toLowerCase()
//     // );
//     // if (existingSkill) {
//     //   Toast.error("Skill name already exists");
//     //   return;
//     // }

//     const response = await aiDishaApi.post("/admin-skills/", {
//       // params: {
//         skill_name: skillName,
//         admin_id: admin_id,
//         // creation_date: creationDate,
//         // status: "Active"
//       // }
//     });

//     if (response.status === 200) {
//       Toast.success("Skill added successfully");
//       setSkillName(""); 
//       setSelectedSkill(""); 
//       // fetchData(); 
//     }
//   } catch (error) {
//     if (error.response?.status === 409) {
//       Toast.error("This skill already exists in the system");
//     } else {
//       Toast.error("Failed to add skill. Please try again.");
//       console.error("Error:", error);
//     }
//   }
// };

  const handleEdit = (id, name) => {
    setSkillId(id);
    setEditedName(name);
    setSkillName(name);
    setIsEdit(true);
  };

  const handleSkillEdit = async (skill_id) => {
    try {
      const existingSkill = skillData.find(
        (skill) => skill.skill_name === skillName && skill.skill_id !== skill_id
      );
      if (existingSkill) {
        Toast.error("Skill name already exists");
        return;
      }

     // Build FormData since backend expects form inputs
    const formData = new FormData();
    formData.append("skill_name", skillName);

    const updateResponse = await aiDishaApi.put(
      `/admin-skills-update/${skill_id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

      if (updateResponse.status === 200) {
        Toast.success("Skill updated successfully");
        setSkillName("");
        // fetchData();
        fetchSkillsForDropdown();
        setIsEdit(false);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setEditingRowId(null);
    }
  };

  const handleClear = () => {
    setSkillName("");
    setSelectedSkill(""); // Clear the dropdown selection
    setSkillId(null);
    setSearchTerm(""); // Clear search term
  };

  const handleModalOpen = (skill_id,status) => {
    setDeactiveId(skill_id);
    setSelectedStatus(status);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleDeactivateSkill = async (skill_id, currentStatus) => {
    try {
      const newStatus = currentStatus  === "Active" ? "Inactive" : "Active";

      // const response = await aiDishaApi.patch(`/update-admin-skills-status/${skill_id}/status?status_update=Inactive`);
      const response = await aiDishaApi.patch(
      `/update-admin-skills-status/${skill_id}/status`,
      null, // no body, since it's query params
      {
        params: { status_update: newStatus },
      }
    );

      if (response.status === 200) {
        Toast.success("Skill deactivated successfully");
        // fetchData();
        fetchSkillsForDropdown();
        handleModalClose();
      }
    } catch (error) {
      console.error("Error:", error);
      Toast.error("Failed to deactivate skill");
    }
  };

  const skillHeader = [
    {
      id: "Skill ID",
      name: "Skill Name",
      creationDate: "Creation Date",
      action: "Action",
    },
  ];

  const CssTextField = styled(TextField)({
    "& label": {
      color: "#FEFEFE",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#B9B9B9",
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: "#B9B9B9",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B9B9B9",
      },
      "& .MuiInputBase-input": {
        color: "#FEFEFE",
      },
    },
  });

  return (
    <div>
      {isEdit ? (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            background: COLORS.primary,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
            >
              Add Skill
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: COLORS.text }}
            >
              Add the name of the Skill
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                backgroundColor: COLORS.background, // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color: COLORS.text }}
                aria-label="search"
              >
                < SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, 
                  fontFamily: "Poppins", 
                  color: COLORS.text,
                  "& input::placeholder": {
                     color: `${COLORS.text} !important`, // 👈 placeholder color
                     opacity: 10, // important (MUI reduces opacity by default)
                   },
                 }} // Set text color to white
                placeholder="Search by Skill Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          <Box gridColumn="span 5" sx={{ marginTop: "auto", textAlign: "left" }}>
            <Typography sx={{ fontFamily: "poppins", color:COLORS.text }}>
              Skill Name
              <span style={{ color: "red" }}>*</span>
            </Typography>

             <TextField
                          size="small"
                          id="outlined-input"
                          label="Skill Name"
                          variant="outlined"
                          value={skillName}
                          onChange={(e) => setSkillName(e.target.value)}
                          sx={{
                            background:COLORS.background,
                            borderRadius:2,
                            width: "95%",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: COLORS.border,
                              borderRadius: "10px",
                            },
                            "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                              {
                                borderColor:COLORS.border,
                              },
                            "& .MuiInputLabel-root": {
                              color: COLORS.text,
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: COLORS.text, // Optional: Change label color when focused
                            },
                            "& .MuiInputBase-input": {
                              color: COLORS.text, // This sets the text color to white
                            },
                            "& .MuiOutlinedInput-root": {
                              color: COLORS.text, // This also helps with input text color
                            },
                          }}
                          required
                        />

            {/* <select
              name="skill"
              className="form-select form-select-sm"
              aria-label="Small select example"
              style={{
                backgroundColor: "#1E1E1E",
                color: "white",
                border: "none",
              }}
              value={selectedSkill}
              onChange={handleSkillChange}
            >
              <option value="" disabled>
                Select Skill
              </option>
              {skillsList.map((skill) => (
                <option key={skill.skill_id} value={skill.skill_name}>
                  {skill.skill_name}
                </option>
              ))}
            </select> */}
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: COLORS.button,
                "&:hover": {
                  color: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              sx={{
                 background: COLORS.button,
                color: COLORS.background,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={() => handleSkillEdit(skillId)}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.background }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            background: COLORS.primary,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
            >
              Add Skill
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: COLORS.text }}
            >
              Add the name of the Skill
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                background: COLORS.background, // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color: COLORS.text }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, 
                  fontFamily: "Poppins", 
                  color: COLORS.text,
                 "& input::placeholder": {
                     color: `${COLORS.text} !important`, // 👈 placeholder color
                     opacity: 10, // important (MUI reduces opacity by default)
                   }, }} // Set text color to white
                placeholder="Search by Skill Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          <Box gridColumn="span 5" sx={{ marginTop: "auto", textAlign: "left" }}>
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              Skill Name
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
                          size="small"
                          id="outlined-input"
                          label="Skill Name"
                          variant="outlined"
                          value={skillName}
                          onChange={(e) => setSkillName(e.target.value)}
                          sx={{
                            background:COLORS.background,
                            borderRadius:2,
                            width: "95%",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: COLORS.border,
                              borderRadius: "10px",
                            },
                            "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: COLORS.border,
                              },
                            "& .MuiInputLabel-root": {
                              color: COLORS.text,
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: COLORS.text, // Optional: Change label color when focused
                            },
                            "& .MuiInputBase-input": {
                              color: COLORS.text, // This sets the text color to white
                            },
                            "& .MuiOutlinedInput-root": {
                              color: COLORS.text, // This also helps with input text color
                            },
                          }}
                          required
                        />
            {/* <select
              name="skill"
              className="form-select form-select-sm"
              aria-label="Small select example"
              style={{
                backgroundColor: "#006A71",
                color: "white",
                border: "none",
              }}
              value={selectedSkill}
              onChange={handleSkillChange}
            >
              <option value="" disabled style={{ color: "white",backgroundColor: "#006A71" }}>
                Select Skill
              </option>
              {skillsList.map((skill) => (
                <option key={skill.skill_id} value={skill.skill_name} style={{ color: "white" ,backgroundColor:"#006A71"}}>
                  {skill.skill_name} 
                </option>
              ))}
            </select> */}
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
               color: COLORS.button,
                "&:hover": {
                  color: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              sx={{
                background: COLORS.button,
                color: COLORS.background,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={handleSkillSubmit}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.background }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
       )} 

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ background: COLORS.primary }}>
                  {skillHeader.map(({ id, name, creationDate, action }) => (
                    <React.Fragment key={id}>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {id}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          cursor: "pointer",
                        }}
                        onClick={() => handleSort("skill_name")}
                      >
                        {name} {sortingOrder === "asc" ? "↑" : "↓"}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {creationDate}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {action}
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableHead>
                <TableBody>
                  {skillsList &&
                    skillsList
                      .filter(
                        (row) =>
                          row.skill_name &&
                           row.skill_name.toLowerCase().includes(searchTerm.toLowerCase())
                        // (row) =>
                        // row.skill_name.toLowerCase().includes(searchTerm.toLowerCase())
                      )
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((n, index) => (
                        <TableRow
                          key={n.skill_id}
                          sx={{
                            background: COLORS.background,
                            marginRight: "30px",
                          }}
                        >
                          <TableCell
                            sx={{ color: COLORS.text, border: COLORS.secondary }}
                          >
                            {n.skill_id}
                          </TableCell>
                          <TableCell
                            sx={{ color: COLORS.text, border: COLORS.secondary }}
                          >
                            {n.skill_name}
                          </TableCell>
                          <TableCell
                            sx={{ color: COLORS.text, border: COLORS.secondary }}
                          >
                            {new Date(n.creation_date).toLocaleDateString("en-GB")}
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: COLORS.secondary,
                              borderRight: COLORS.secondary,
                              display: "flex",
                              alignItems: "center",
                              fontFamily: "poppins",
                            }}
                          >
                              {editingRowId === n.skill_id ? (
                              <Button
                                variant="contained"
                                sx={{
                                 background: COLORS.button_edit_bg,
                                                                   "&:hover": {
                                                                     background: COLORS.hover_edit_btn,
                                                                   },
                                                                   color: COLORS.background,
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Save
                              </Button>
                              ) : (
                              <Button
                                variant="contained"
                                onClick={() =>
                                  handleEdit(n.skill_id,n.skill_name)
                                }
                                sx={{
                                  background: COLORS.button_edit_bg,
                                  "&:hover": {
                                    background: COLORS.hover_edit_btn,
                                  },
                                  color: COLORS.background,
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Edit
                              </Button>
                            )}


                            <Button
                              variant="contained"
                              sx={{
                              background:
                                  n.status === "Active" ? COLORS.button_red_bg : COLORS.button_green_bg,
                                // color: "#ffffff",
                                color: COLORS.text,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                                "&:hover": {
                                background:
                                  n.status === "Active"
                                    ? COLORS.hover_red_btn      // hover when Active (Deactivate button)
                                    : COLORS.hover_green_btn,   // hover when Inactive (Activate button)
                              },
                              }}
                              onClick={() => handleModalOpen(n.skill_id, n.status)}
                              color="error"
                            >
                              {n.status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                              {/* Deactivate */}
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={skillsList ? skillsList.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  background:COLORS.primary,
                  color: COLORS.text,
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="Skill"
        action={() => handleDeactivateSkill(deactivateId, selectedStatus)}
        actionType={selectedStatus === "Active" ? "Deactivate" : "Activate"}

      />
    </div>
  );
};

export default SkillManagement;